import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';

import { AuthService } from './auth.service';
import { Observable, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TopService } from '../shared/services/top.service';
import { UserService } from '../user/user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService, public topservice: TopService, private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.auth.isAuthenticated() && !this.auth.isGuest) {
      this.router.navigate(['']);
    }
    this.topservice.xPath = this.topservice.xPath + 1;

    const headers: { [name: string]: string } = {
      Authorization: `Bearer ${this.auth.getAccessToken()}`,
      'Access-Control-Allow-Origin': '*',
      'X-Generation': this.topservice.xPath.toString()
    };

    // Make sure this tab has settled on its own impersonation id before we send the header —
    // otherwise a duplicated tab could send the original tab's id. AuthService decides which
    // requests need this (impersonation roles only, and not the bootstrap calls themselves).
    if (this.auth.shouldSendWithImpersonation(request)) {
      return this.sendImpersonationRequest(request, next, headers);
    }

    request = request.clone({ setHeaders: headers });
    return next.handle(request);
  }

  /**
   * Waits for this tab to settle on its impersonation id, then sends the request with that id in a
   * header. The wait only happens on the first request (the result is cached); later requests are
   * instant.
   */
  private sendImpersonationRequest(
    request: HttpRequest<any>, next: HttpHandler, headers: { [name: string]: string }
  ): Observable<HttpEvent<any>> {
    return from(this.auth.ensureImpersonation()).pipe(
      mergeMap(() => {
        const impersonationId = this.auth.impersonationId;
        if (impersonationId) {
          headers['X-Impersonation-Id'] = impersonationId;
        }
        return next.handle(request.clone({ setHeaders: headers }));
      })
    );
  }
}
